import jobsActions from './jobs';

export default {
  ...jobsActions
};
